import React from "react";
import NotificationCard from "../NotificationCard/NotificationCard";
import styles from "./style.module.css";

const NotificationList = ({
  notifications,
  notificationCardVariant = "rounded",
}) => {
  return (
    <div className={styles.notificationList}>
      {notifications.map((notification) => (
        <NotificationCard
          notification={notification}
          variant={notificationCardVariant}
        />
      ))}
    </div>
  );
};

export default NotificationList;
